import React from 'react';
import Slider from 'react-slick';

const TestimonialKeyword = ({ testimonials }) => {
  // Slider settings for showing 3 slides at a time on larger screens
  const settings = {
    infinite: true,  // Infinite loop (loop through the slides)
    autoplay: true,  // Enable auto-slide
    autoplaySpeed: 2000,  // Auto-slide speed (2 seconds for smoother transition)
    dots: true,  // Show navigation dots
    arrows: false,  // Disable arrows
    speed: 1000,  // Transition speed (1 second)
    slidesToShow: 2,  // Show 3 slides at a time on larger screens
    slidesToScroll: 1,  // Scroll 1 slide at a time
    responsive: [
      {
        breakpoint: 1024,  // For screens smaller than 1024px
        settings: {
          slidesToShow: 2,  // Show 2 slides at a time
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,  // For screens smaller than 768px
        settings: {
          slidesToShow: 1,  // Show 1 slide at a time on mobile
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <section className="testimonial-section-four">
      <div className="bg bg-image"></div>
      <div className="container pt-0 pb-0">
        <div className="sec-title text-center">
          <span className="sub-title line-style">testimonials</span>
          <h2 className="letters-slide-up text-split">Our Customer Say</h2>
        </div>
        <div className="outer-box">
          {/* React Slick Slider */}
          <Slider {...settings} className="testimonial-carousel-two">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="testimonial-block-four">
                <div className="inner-box">
                  <div className="content">
                    <div className="text">{testimonial.text}</div>
                    <div className="box-info">
                      <div className="author-box">
                        <figure className="author-image">
                          {/* <img src={testimonial.image} alt={testimonial.name} /> */}
                        </figure>
                        <div className="author-info">
                          <h6 className="name">{testimonial.name}</h6>
                          <span className="designation">{testimonial.designation}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default TestimonialKeyword;
